module.exports = __webpack_public_path__ + "static/media/mode-8.171e1f62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-8.svg
// module id = 981
// module chunks = 2